var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "url(#paint0_linear_2309_145256)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49656 8.27907L9.628 7.61695C9.69895 7.25947 10.0131 7 10.3749 7H14.6255C14.9873 7 15.3014 7.25947 15.3724 7.61695L15.5038 8.27907H9.49656ZM12.5 15.5953C11.3641 15.5953 10.4434 14.6676 10.4434 13.5232C10.4434 12.3789 11.3641 11.4511 12.5 11.4511C13.6358 11.4511 14.5566 12.3789 14.5566 13.5232C14.5566 14.6676 13.6358 15.5953 12.5 15.5953ZM17.8574 9.04652H7.14258C6.51256 9.04652 6 9.56294 6 10.1977V16.8488C6 17.4836 6.51256 18 7.14258 18H17.8574C18.4874 18 19 17.4836 19 16.8488V10.1977C19 9.56294 18.4874 9.04652 17.8574 9.04652ZM16.9688 11.4512H15.75C15.5397 11.4512 15.3691 11.2794 15.3691 11.0675C15.3691 10.8555 15.5397 10.6837 15.75 10.6837H16.9688C17.1791 10.6837 17.3496 10.8555 17.3496 11.0675C17.3496 11.2794 17.1791 11.4512 16.9688 11.4512ZM15.3184 13.5233C15.3184 15.089 14.0541 16.3628 12.5 16.3628C10.9459 16.3628 9.68164 15.089 9.68164 13.5233C9.68164 11.9575 10.9459 10.6837 12.5 10.6837C14.0541 10.6837 15.3184 11.9575 15.3184 13.5233Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2309_145256",
    x1: 5.5,
    y1: 5.5,
    x2: 21.875,
    y2: 20.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC90C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#14C7EE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.4dabc42800d2a5c0b171963ef7d36337.svg";
export { ForwardRef as ReactComponent };